<div class="revenue-summary">
    <div id="revenue-summary-chart"></div>
</div>